import React from 'react'
import { Box, Typography } from '@mui/material'
import MaterialSymbol from '../../../components/MaterialSymbol'
import DeclarationModal from './DeclarationsModal'
import TestIds from '../../../testIds'
import { TextIconButton } from '../../../components/TextIconButton'
import { colors } from '../../../themes/colors'
import { useAppDispatch } from '../../../store/rootStore'
import { getDeclarations } from '../declarations.slice'

interface Props {
  children?: React.ReactNode | React.ReactNode[]
}

export const Declarations = (props: Props) => {
  const [open, setOpen] = React.useState(false)
  const dispatch = useAppDispatch()

  const close = React.useCallback(() => {
    setOpen(false)
  }, [])

  const onClick = React.useCallback((e: React.MouseEvent<HTMLDivElement>) => {
    setOpen(true)
    dispatch(getDeclarations())
    e.stopPropagation()
  }, [])

  return (
    <Box onClick={onClick} display='inline-flex' flexGrow='1'>
      {props.children ?? <DeclarationsButton />}
      <DeclarationModal open={open} handleClose={close} />
    </Box>
  )
}

export const DeclarationsButton = () => {
  return (
    <TextIconButton
      data-testid={TestIds.feat.declarations.openDeclarations}
      color={colors.primary700}
    >
      <MaterialSymbol>folder</MaterialSymbol>
      <Typography variant='body2' color={'inherit'} sx={{ textDecoration: 'underline' }}>
        Declarations
      </Typography>
    </TextIconButton>
  )
}

export default Declarations
